import { connect } from 'react-redux';
import CreditsHistoryModal from "./CreditsHistoryModal";
import { getTranslation } from "../../../../../reducers/common/localization";
import {
    getActiveModal,
    hideModal,
    MODAL_COMPANY_CREDITS_HISTORY_MODAL
} from '../../../../../reducers/common/activeModal';
import {
    getCompanyHistoryData,
    getSelectedCompanyName,
    loadingCompanyHistory
} from '../../../../../reducers/systemPayments/companiesCredits';

const mapStateToProps = state => {
    return {
        companyName: getSelectedCompanyName(state),
        data: getCompanyHistoryData(state),
        isOpen: getActiveModal(state).modalKey === MODAL_COMPANY_CREDITS_HISTORY_MODAL,
        translation: getTranslation(state),
        loading: loadingCompanyHistory(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCancel: () => {
            dispatch(hideModal());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditsHistoryModal);



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/companiesCreditsList/creditsHistoryModal/CreditsHistoryModal.container.js